import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons';

// Styles
import styles from './ColumnGroupListItem.module.css';

// Components
import Picto from '../../atoms/Picto/Picto';

/**
 * Single drag handle for a contiguous column group; labels stacked vertically.
 * @param {object} props
 * @param {string} props.id - Sortable id (must match SortableContext)
 * @param {ApiManagerTableFiltersColumnFilters[]} props.columns
 * @param {boolean} [props.isDisabled = false]
 * @param {React.ReactNode | null} [props.children = null]
 * @returns {JSX.Element}
 */
function ColumnGroupListItem({
  id,
  columns,
  isDisabled = false,
  children = null,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: isDisabled,
  });

  const title = columns.map((c) => c.lib).join('\n');

  return (
    <button
      type="button"
      className={styles.item}
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 2 : 'auto',
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...attributes}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...listeners}
    >
      <div className={styles['item-info']}>
        <div className={styles['item-info-left']}>
          {!isDisabled ? (
            <Picto
              icon="drag-horizontal"
              className={styles['dnd-icon']}
            />
          ) : null}
          <div className={styles['stacked-names']} title={title}>
            {columns.map((c) => {
              const hasColor = c.color && c.color !== 'transparent';
              return (
                <span key={c.id} className={styles['name-line']}>
                  {hasColor ? (
                    <FontAwesomeIcon
                      icon={faSquare}
                      className={styles['item-color-icon']}
                      style={{ color: c.color }}
                      aria-label={`Couleur: ${c.color}`}
                    />
                  ) : null}
                  {c.lib}
                </span>
              );
            })}
          </div>
        </div>
        <div className={styles['item-info-right']}>
          {children || null}
        </div>
      </div>
    </button>
  );
}

export default ColumnGroupListItem;
